import { css, type DefaultTheme, type FlattenInterpolation, type ThemeProps } from 'styled-components';

export const getDangerousButtonStyle = (): FlattenInterpolation<ThemeProps<DefaultTheme>> => css`
  color: ${({ theme }) => theme.color.status.error};
  background-color: ${({ theme }) => theme.color.grey.white};
  border-style: none;

  &:hover {
    background-color: ${({ theme }) => theme.color.status.backgroundFill.error};
    color: ${({ theme }) => theme.color.status.error};
  }

  &:focus-visible {
    color: ${({ theme }) => theme.color.status.error};
    background-color: ${({ theme }) => theme.color.grey.white};
    outline-color: ${({ theme }) => theme.color.status.error};
  }

  &:active {
    background-color: ${({ theme }) => theme.color.status.backgroundFill.error};
    color: #d43133;
  }

  &:disabled {
    background-color: ${({ theme }) => theme.color.grey.grey4};
    color: ${({ theme }) => theme.color.type.disabled};
    border-style: none;
    text-decoration: none;
  }
`;
